import Button from "components/common/controls/Button";

export interface EditorActionButtonProp {
  cancelButtonCaption?: string;
  applyButtonCaption?: string;
  onApply?: Function;
  onCancel?: Function;
  useSubmitBehaviorOnApply?: boolean;
}

export default function ModalActionFooter(props: EditorActionButtonProp) {
  const {
    onApply,
    onCancel,
    applyButtonCaption,
    cancelButtonCaption,
    useSubmitBehaviorOnApply,
  } = props;
  
  return (
    <div>
      <Button
        text={cancelButtonCaption}
        variant="secondary"
        className="mr-2"
        onClick={() => onCancel?.()}
      />
      <Button
        text={applyButtonCaption}
        useSubmitBehavior={useSubmitBehaviorOnApply}
        onClick={() => onApply?.()}
      />
    </div>
  );
}

ModalActionFooter.defaultProps = {
  cancelButtonCaption: "Cancel",
  applyButtonCaption: "Ok",
};
